import React, { Component } from 'react';
import Loading from './img/loading.gif';


export  class Loader extends Component {

    
    constructor(props) {
        super(props)
        this.props = props 
    }

    render() {
        return (
            <div>
                {this.props.loader == true ? 
            
            <div className='LoaderDiv'><img src={Loading} /></div> : null
            }
            

            </div>
            
        )
    }

}


